var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05 17.32a7.007 7.007 0 0 1 0-9.9 7.007 7.007 0 0 1 9.9 0 7.007 7.007 0 0 1 0 9.9A6.973 6.973 0 0 1 12 19.37c-1.79 0-3.58-.68-4.95-2.05zm1.06-8.84a5.517 5.517 0 0 0 0 7.78 5.507 5.507 0 0 0 7.78 0 5.517 5.517 0 0 0 0-7.78A5.49 5.49 0 0 0 12 6.87c-1.41 0-2.82.54-3.89 1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97 22.34c-2.25-.9-4.07-2.49-5.29-4.59a10.6 10.6 0 0 1-1.34-6.73c.05-.41.43-.7.84-.65.41.05.699.43.649.84-.26 2.02.14 4.02 1.15 5.78a9.104 9.104 0 0 0 4.54 3.94c.38.16.57.59.42.98-.11.3-.4.48-.69.48-.09 0-.19-.02-.28-.05zM5.26 4.94c-.26-.33-.2-.8.13-1.05C7.3 2.4 9.58 1.61 12 1.61c2.36 0 4.61.76 6.5 2.2A.749.749 0 1 1 17.59 5 9.111 9.111 0 0 0 12 3.11c-2.08 0-4.05.68-5.69 1.96-.14.11-.3.16-.46.16-.22 0-.44-.1-.59-.29zM15.05 21.92a.76.76 0 0 1 .42-.98c1.93-.78 3.5-2.14 4.54-3.94a9.044 9.044 0 0 0 1.15-5.78c-.05-.41.24-.79.65-.84.4-.05.79.24.84.65.3 2.35-.16 4.68-1.34 6.73-1.21 2.1-3.04 3.68-5.29 4.59-.08.02-.17.04-.27.04-.3 0-.58-.18-.7-.47z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineStory);
export default __webpack_public_path__ + "static/media/vuesax-outline-story.1539380e1fc7f4a6f2d286bdbd769343.svg";
export { ForwardRef as ReactComponent };